import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function OnboardingWizard({ onClose }) {
  const navigate = useNavigate();

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-sm rounded-3xl text-center">
        <h2 className="text-2xl font-heading font-bold">Set up Marstick</h2>
        <p className="text-sm text-muted-foreground">Complete a skippable 5-step setup in under 90 seconds.</p>
        <div className="flex flex-col gap-2 pt-2">
          <Button onClick={() => { onClose?.(); navigate("/onboarding"); }}>Start setup</Button>
          <Button variant="ghost" onClick={onClose}>Not now</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}